import React, { useEffect, useState, useContext } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import {
	IconButton,
	Typography,
	InputLabel,
	MenuItem,
	FormControl,
	Select,
	Accordion,
	Box,
	Button,
	ListItemText,
	Menu,
	ListItemIcon,
	Divider,
	Tooltip,
	Link
} from '@material-ui/core';
import ChipInput from './ChipInput';
import { colors } from 'theme/color-palette';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import {
	StringCondition,
	NumberCondition,
	hideValueInput,
	getInputLenAllowed,
	shouldShowRangeInput,
	isNullField,
	DCWMTCal,
	OmniWMTCal,
	SSIWMTCal,
	MUMDMTCal,
	OmniStdCal,
	isCalFamily,
	customDtCondition,
	StoreDemandCal,
	StoreOrderCal,
	demandFrcstWkCal,
	orderFrcstWkCal,
	isMultiTimeFilterEnabled,
	isMultiWeekSel,
	EqualsToCondition,
	otherDtConditions,
	hideDateRangeInput,
	EqualsToConditionOnly,
	POCal,
	TraitNumberConditions,
	ContainsConditionOnly,
	POWMTCal,
	isMTS,
	wmtLastOneHundredAndFourWeeks,
	HistoricalReportOmniCal
} from './FilterCondition';
import styles, { StyledAccordionSummary } from './FilterForm.style';
import { getDateRange, getMutlipleDateRange } from 'helper/dateRange';
import { useSelector, useDispatch } from 'react-redux';
import {
	CANCEL_BUTTON,
	FORM_SEL_CONDITION_LBL,
	CLEAR_ALL,
	TIME_LAG,
	OTIF_TMPT_LIST,
	HISTORICAL_REPORT_OMNI,
	PARENT_CUST_ATTR,
	STR_TMPT_LIST,
	DC_TMPT_LIST,
	STR_DEMAND_LIST,
	FILTER_CONDITION_LABELS,
	FILTER,
	NO_FILTER,
	TIME_FILTER_REQ,
	STR_ORDER_LIST,
	WM_YR_WK_NO,
	// CUSTOM_DT_DIM,
	CANNED_REPORT_LIST,
	EXCEED_MAX_LIMIT,
	MOD_TMPT_LIST,
	MAX_FILTER_VALUE,
	MAX_INT_FILTER_VALUE,
	PLACEHOLDER_TXT,
	MUMD_ORDER_LIST,
	ECOM_INVENTORY,
	OMNI_TMPT_LIST,
	REQUIRED_FILTERS,
	OPTIONAL,
	ADD_FILTER_VAL,
	SELECT_FROM_ALL,
	DATA_IN_USE,
	APPLY,
	EDIT_FILTER_VALUE,
	SELECT_VALUE,
	NO_OPTIONAL_FILTER_SELECTED,
	GUIDE_TO_ADD_OPTIONAL_FILTER1,
	GUIDE_TO_ADD_OPTIONAL_FILTER2,
	STR_ORDER_FIELDS_WITH_FUZZY,
	BASIC,
	ECOM_SALES_LIST,
	BOT_MODAL_FILTER_MSG,
	MANDATE_FILTER_MSG,
	BLOCKED_PREVIEW_DIALOG_CONTENT_SSI,
	SSI_STORE_TRAIT_ATTRS,
	PURCHASE_ORDER_LIST,
	MULTI_TIME_SELECTION,
	TRAIT_NUMBER,
	SSIContainsOnlyColumns,
	PO_DATE_LIST,
	WALMART_CALENDAR,
	PIVOT_COLUMN_LIMIT,
	SHOW_AS_CANNED_REPORT,
	SHOW_ADVANCED_OPTIONS_LIST,
	ADVANCED_OPTIONS,
	TENDER_ANALYSIS_LIST,
	REQUIRED_FILTER_MSG,
	SHIP_TO_ZIP_LIST,
	FILTER_LOWER,
	PROTIP_TEXT_104_WEEKS,
	PIVOT_SINGLE_TIME_VALUE_MAP,
	PROTIP_LEARN_MORE,
	PROTIP_LEARN_MORE_BASIC,
	ADVANCED_TEMPLATES,
	LEARN_MORE,
	WARNING_104_WEEKS_TEXT,
	DATE_KEY,
	CHARTER,
	PERSONA,
	REGISTER_SALES_LIST
} from 'constants/constant';
import { _isEqual, deepClone, compareObj, getKeyByValue } from 'helper/helper';
import { build } from 'helper/build';
import APIURLPATH from 'constants/apiconstants';
import DateRangeInput from './DateRangeInput';
import { getAuthHeader } from 'helper/authHeader';
import { UserPortalContext } from 'context/appcontext';
import Tour from 'components/UserTour/Tour';
import { FilterFormSteps } from 'components/UserTour/Steps';
import {
	setSelectedList,
	addPreviewColumn,
	removePreviewColumn,
	setPrevFilterList,
	setFilterList,
	setIsMandateCheck,
	clearPreview,
	setIsMTSFilterCollapsed,
	resetPivotOptions,
	setPivotOptions,
	setRequiredCheck,
	saveItemShareStatus
} from '../Preview.actions';
import {
	buildBusinessName,
	removeItemsFromFilterList,
	validateDimFilters,
	isDefaultFilter,
	enableFilter,
	hasPivotedColumn,
	calculateTotalColumnCount,
	isVariantID
} from '../Preview.utils';
import classNames from 'classnames';
import moment from 'moment';
import ShowDateElements from './ShowDateElements';
import {
	getDfltFilter,
	getTmplName,
	isCustomDataset,
	isBasicPersona,
	computeIncompatibilityObject,
	determine104WeeksFeatureInFilter,
	determine104WeeksFeatureInFilterList,
	remove104WeeksOptions
} from 'helper/utils';
import MultiSelectInputCondition from './MultiSelectConditionInput';
import RBButton from 'components/Shared/RBButton';
import FilterListIcon from '@material-ui/icons/FilterList';
import FilterExpanded from './FilterExpanded.component';
import AddIcon from '@material-ui/icons/Add';
import dateIcon from 'assets/svgs/date.svg';
import textIcon from 'assets/svgs/text.svg';
import accessTime from 'assets/svgs/access_time.svg';
import integerIcon from 'assets/svgs/nonText.svg';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { BLOCKED_STATUS_CODE, setPXProperties } from 'helper/perimeterX';
import PreviewDialog from 'components/Shared/DialogBox';
import PerimeterXCaptcha from 'components/Shared/PerimeterXCaptcha';
import { trackEventInfo } from 'helper/analytics';
import { EVENTS, PAGE_ID, ACTION_ON } from 'constants/tracker';
import { MultiTimeSelectionFilter, MultiTimeSelectionWidget } from '../multi-time-selection';
import { VisualHierarchyWidget } from '../visual-hierarchy';
import { getSavedCustomDatasetWithAttributes, getBaseUrl } from 'helper/utils';
import { getStartAndEndDates } from 'helper/dateRange';
import { getFuzzyOptions } from 'helper/utils';

const listTypes = ['dimensions', 'measures', PARENT_CUST_ATTR];
const specificTmplList = [...STR_DEMAND_LIST, ...STR_ORDER_LIST, ...CANNED_REPORT_LIST];
const selectAll = 'Select All';
const dateFormat = 'MM/DD/YYYY';
/**
 * | usrSelection = is a array. Length will be 1 when user clicks on any particular attribute.
 * | usrSelection = is a array. Length will be 0 when user clicks on "Filter title of the preview element component".
 * | cbSetShowPreviewElement - cb function to navigate to previous screen/component.
 */

function FilterForm({
	cbSetShowPreviewElement,
	usrSelection,
	drawerWidth = 360,
	fromWhere,
	mtsSubAttr,
	ssiCompatibility,
	cbSSIComptability
}) {
	const [value, setValue] = useState([]);
	const [expanded, setExpanded] = useState('');
	const [filterState, setFilterState] = useState([]);
	const [prevFilterState, setPrevFilterState] = useState([]);
	const [rangeList, setRangeList] = useState({ min: [], max: [] });
	const [options, setOptions] = useState(null);
	const [loading, setLoading] = useState(false);
	const [runTour, setRunTour] = useState(false);
	const [tourSteps, setTourSteps] = useState(FilterFormSteps);
	const [filterValueReadOnly, setFilterValueReadOnly] = useState(false);
	const [multiCondition, setmultiCondition] = useState([]);
	const [isMultiFilter, setIsMultiFilter] = useState(true);
	const [filterObj, setFilterObj] = useState({});
	const [showExpandedFilter, setShowExpandedFilter] = useState(false);
	const [addFilterAnchorEl, setAddFilterAnchorEl] = useState(null);
	const [localUsrSelection, setLocalUsrSelection] = useState([]);
	const [showMTSWidget, setShowMTSWidget] = useState(false);
	const [showVHWidget, setShowVHWidget] = useState(false);
	const [mtsState, setMTSState] = useState({});
	const [metricCalcAttr, setMetricCalcAttr] = useState(ssiCompatibility);
	const [isConditionChanged, setIsConditionChanged] = useState(false);

	const dispatch = useDispatch();
	const portalUserContext = useContext(UserPortalContext);
	const { userDetails, customerType } = portalUserContext;
	const { companyName, loginId, userPersona, blackOut } = userDetails?.result;
	const previewUsrFilterList = useSelector((state) => state.previewReducer.filterList);
	const { selectedList, pivotOpts } = useSelector((state) => state.previewReducer);
	const templateId = useSelector((state) => state.templateReducer.selectedTemplate);
	const selectedView = useSelector((state) => state.templateReducer.selectedView);
	const previewData = useSelector((state) => state.previewReducer.previewData);
	const templateData = useSelector((state) => state.templateReducer.templateData);
	const sbuDBTechNames = useSelector((state) => state.templateReducer.sbuDimDBTechName);
	const sbuDepartments = useSelector((state) => state.templateReducer.sbuDepartments);
	const cannedReportData = useSelector((state) => state.templateReducer.cannedReportData);
	const isDimFilterMandate = useSelector((state) => state.previewReducer.isDimFilterMandate);
	const isCalFilterApplied = useSelector((state) => state.previewReducer.isCalFilterApplied);
	const savedCustomDatasets = useSelector((state) => state.templateReducer.savedCustomDatasets);
	const customDatasetDetails = useSelector((state) => state.templateReducer.customDatasetDetails);
	const customAttribute = useSelector((state) => state.templateReducer.customAttribute);
	const calendarRollDim = useSelector((state) => state.dashboardReducer.calendarRollDim);
	const shouldTourSkip = localStorage.getItem('FilterFormTourSkip');
	const tourCurrStep = localStorage.getItem('FilterFormCurrStep');
	const [showCaptchaDialogBox, setShowCaptchaDialogBox] = useState(false);

	const isBasic = isBasicPersona(portalUserContext.customerType);

	window._pxOnCaptchaSuccess = (isValid) => {
		if (isValid) {
			setShowCaptchaDialogBox(false);
		}
	};

	useEffect(() => {
		const lSteps = deepClone(FilterFormSteps);
		if (!shouldTourSkip) {
			setRunTour(true);
			const currTourStep = localStorage.getItem('FilterFormCurrStep');
			for (let index = 0; currTourStep !== null && index <= currTourStep; index++) {
				lSteps.shift();
			}
			setTourSteps(lSteps);
			return;
		}
		setRunTour(false);
	}, [shouldTourSkip, tourCurrStep]);

	useEffect(() => {
		if (fromWhere !== 'quickReport') {
			setLocalUsrSelection(usrSelection);
		}
	}, [usrSelection]);

	useEffect(() => {
		setShowVHWidget(false);
	}, [fromWhere, expanded]);

	useEffect(() => {
		const hasCalFilter = filterState.some((_o) => {
			return isCalFamily(_o) && _o.filter.condition !== '';
		});
		dispatch(setRequiredCheck(hasCalFilter));
	}, [filterState]);

	useEffect(() => {
		let currentUsrSelection = localUsrSelection;

		const removeMTSIfNotSelected = (previewFilterList) => {
			return previewFilterList.map((filter) => {
				if (filter?.localName === MULTI_TIME_SELECTION) {
					const newMTSFilter = deepClone(filter);
					const isMTSColumnSelected = selectedList?.some((selectedColumn) => isMTS(selectedColumn));
					// Revert back to a regular walmart week only if MTS is not selected as a column
					// If MTS is selected as a column, then localName and mts shouldnt be deleted.
					if (Object.keys(newMTSFilter?.mts ?? {}).length === 0 && !isMTSColumnSelected) {
						delete newMTSFilter?.localName;
						delete newMTSFilter?.mts;
					}
					return newMTSFilter;
				}
				return deepClone(filter);
			});
		};

		const getInitialState = () => {
			// Removes filter items from the list as per the conditions
			const previewFilterList = removeItemsFromFilterList(
				Number(templateId),
				deepClone(previewUsrFilterList)
			);

			// Below "if" will run when user click on Filter title of the preview element component.
			if (currentUsrSelection.length === 0) {
				if (previewFilterList.length === 0) {
					return [];
				}

				/**
				 * If multi time filter is enabled for the filter
				 * Or If linked items activity has some value then disable show as col
				 * Or for OMNI OTIF template attribute is business_area
				 */
				previewFilterList.map((filter, index) => {
					if (isCalFamily(filter)) {
						// If MTS 2.0 is selected as a column first and then the user directly navigates to the filter section
						// then the localName must be set to MTS on the default "week" filter to avoid any errors.
						// Reference incident: INC44451019
						const multiTimeSelectedColumn = selectedList?.find((item) => isMTS(item));
						if (multiTimeSelectedColumn) {
							previewFilterList[index] = {
								...previewFilterList[index],
								localName: multiTimeSelectedColumn.localName
							};
						}

						if (isMultiTimeFilterEnabled(filter, Number(templateId))) {
							const multiConditions = filter.filter?.condition?.split(',');
							if (multiConditions?.length === 6) {
								multiConditions.unshift(selectAll);
							}
							setmultiCondition(multiConditions ? multiConditions : []);
						}
						/**
						 * If filter has not been applied yet then check in selectedList if any timeframe has been selected to give the default option
						 * second AND condition is basically checking if MTS is also empty
						 */

						const timeFilter = selectedList.find((item) => isCalFamily(item));
						if (filter.filter.condition === '' && Object.keys(filter?.mts ?? {}).length === 0) {
							if (
								timeFilter &&
								timeFilter.businessName !== 'Walmart Week' &&
								PURCHASE_ORDER_LIST.includes(Number(templateId))
							) {
								previewFilterList[index] = { ...timeFilter, filter: { condition: '', value: [] } };
							}
						}
						if (
							previewFilterList[index].dataType === 'date' &&
							timeFilter &&
							timeFilter.parent !== previewFilterList[index].parent
						) {
							previewFilterList[index] = {
								...timeFilter,
								filter: { condition: '', value: [] }
							};
						}

						const filters = getDefaultFilterData();
						if (
							!timeFilter &&
							filters[index]?.technicalName !== previewFilterList[index].technicalName &&
							!previewFilterList[index].filter.condition
						) {
							previewFilterList[index] = {
								...filters[index],
								filter: { condition: '', value: [] }
							};
						}
					}
				});

				return removeMTSIfNotSelected(previewFilterList);
			}

			// when user select any selected filter individually for edit mode.
			const existingFilterIdx = previewFilterList.findIndex(
				(item) =>
					item.businessName === currentUsrSelection[0].businessName &&
					item.parent === currentUsrSelection[0].parent
			);
			if (existingFilterIdx !== -1) {
				const duplicateList = deepClone(previewFilterList);
				const toEditFilter = duplicateList[existingFilterIdx];
				if (currentUsrSelection[0]?.localName) {
					toEditFilter.localName = currentUsrSelection[0]?.localName;
				}

				/**
				 * If multi time filter is enabled for the filter
				 */
				if (isMultiTimeFilterEnabled(toEditFilter, Number(templateId))) {
					const multiConditions = toEditFilter.filter?.condition?.split(',');
					if (multiConditions?.length === 6) {
						multiConditions.unshift(selectAll);
					}
					setmultiCondition(multiConditions ? multiConditions : []);
				}

				// duplicateList.splice(existingFilterIdx, 1);
				if (toEditFilter.filter.condition === FILTER_CONDITION_LABELS.IS_IN_BETWEEN) {
					setRangeList({
						max: [toEditFilter.filter.value[1]],
						min: [toEditFilter.filter.value[0]]
					});
				}
				return deepClone([...duplicateList]);
			}

			/**
			 * | Below line will run when user clicks on any particular attribute.
			 * | need to explicitly add fitler object as initially it will not be there.
			 */
			const list = deepClone(previewFilterList);
			if (isCalFamily(currentUsrSelection[0])) {
				/**
				 * | As time filter default will be available in filter panel for 'day' grain,
				 * | we need to manually remove from the list, if some other filter grain selected by user.
				 * | Hence, executing shift.
				 */
				const calFamilyIdx = list.findIndex((item) => isCalFamily(item));
				list.splice(calFamilyIdx, 1);
			}
			const isCurrentSelectionAlreadyPresent = list.find((item) => {
				// technical name would be same for all custom attr, hence need to check parent
				if (item.parent !== PARENT_CUST_ATTR) {
					return item?.technicalName === currentUsrSelection[0]?.technicalName;
				} else {
					return item?.businessName === currentUsrSelection[0]?.businessName;
				}
			});

			if (isCurrentSelectionAlreadyPresent) {
				return deepClone([...list]);
			}

			return deepClone([
				...list,
				{ ...currentUsrSelection[0], filter: { condition: '', value: [] } }
			]);
		};

		const initialState = getInitialState();

		setFilterState(initialState);
		setPrevFilterState(initialState);
		dispatch(setFilterList(initialState));

		// to keep accordian in edit mode.
		if (currentUsrSelection.length !== 0) {
			setExpanded(currentUsrSelection[0].businessName);
			if (!isCalFamily(currentUsrSelection[0])) {
				fetchOptions(currentUsrSelection[0]);
			}
		}
	}, [localUsrSelection]);

	useEffect(() => {
		setFilterState(previewUsrFilterList);
	}, [previewUsrFilterList]);

	const handleAccordianExpand = (panelName, item) => {
		const { filter } = item;
		const { condition, value } = filter;
		if (condition === FILTER_CONDITION_LABELS.IS_IN_BETWEEN) {
			if (value.length > 0) {
				value.sort((a, b) => Number(a) - Number(b));
				setRangeList({
					min: value[0] ? [value[0]] : [],
					max: value[1] ? [value[1]] : []
				});
			}
		}
		if (expanded !== panelName) {
			setExpanded(panelName);
			setOptions(null);
			if (!isCalFamily(item)) {
				fetchOptions(item);
			}
		} else {
			setExpanded('');
		}
	};

	/**
	 * Use case: When the user selects a template and goes to the filter for MTS, selects something - at this point
	 * "selectedList" and "multiTimeSelection" will be updated in redux but not "filterList". If the user clicks on cancel
	 * right now, and comes back to MTS filters, the MTS values still show cos "multiTimeSelection" redux value has not been
	 * erased when the user clicked on cancel.
	 * In this useEffect, we update the "multiTimeSelection" with what we have in "filterList"
	 */
	useEffect(() => {
		const oldMTSState = deepClone(
			previewUsrFilterList?.find((filter) => filter?.localName === MULTI_TIME_SELECTION)?.mts ?? {}
		);
		if (oldMTSState?.CUSTOM_DATE_1?.date?.start) {
			oldMTSState.CUSTOM_DATE_1.date.start = moment(
				oldMTSState?.CUSTOM_DATE_1?.date?.startDateString
			);
			oldMTSState.CUSTOM_DATE_1.date.end = moment(oldMTSState?.CUSTOM_DATE_1?.date?.endDateString);
		}
		if (oldMTSState?.CUSTOM_DATE_2?.date?.start) {
			oldMTSState.CUSTOM_DATE_2.date.start = moment(
				oldMTSState?.CUSTOM_DATE_2?.date?.startDateString
			);
			oldMTSState.CUSTOM_DATE_2.date.end = moment(oldMTSState?.CUSTOM_DATE_2?.date?.endDateString);
		}
		if (!isConditionChanged) {
			setMTSState(oldMTSState);
		}
	}, [previewUsrFilterList]);

	const onMTSUpdate = (newMTSState) => {
		setMTSState(newMTSState);
	};

	/** add incompatibility check item when currentIndex === -1, which means value is newly added by list click.
	 * remove incompatibility check item when currentIndex != -1
	 */
	const determineIncompatibility = (value, currentIndex) => {
		const _metricCal = computeIncompatibilityObject(
			value,
			currentIndex,
			templateId,
			metricCalcAttr
		);
		setMetricCalcAttr(_metricCal);
		cbSSIComptability(_metricCal);
	};

	/**
	 * | 1. Search in previewUsrFilterList list using as unique key => technicalName
	 * | 2. If found, get index and update fiter object on that particular index.
	 * | 3.	If not found, add as in new object with filter object to previewUsrFilterList list.
	 * | 4. Dispatch setSelectedList action.
	 */
	const handleOnSave = (panelId) => {
		const newList = deepClone(prevFilterState);
		const index = newList.findIndex((el) => {
			return el.businessName === panelId;
		});

		let _subAtt = {};

		/**
		 * | Below "if" condition to edit old reports where filtertable and filterattr
		 * | will not come in runQueryRequestObject. Hence, need to take it from template data.
		 * |
		 */
		if (isCalFamily(newList[index])) {
			const parent = newList[index].parent;
			const customDatasetReports = getSavedCustomDatasetWithAttributes(
				savedCustomDatasets,
				customDatasetDetails,
				customAttribute
			);
			const data = [...templateData, ...cannedReportData, ...customDatasetReports];
			const allData = data.filter((template, index) => {
				return index === data.findIndex((o) => template.templateId === o.templateId);
			});
			const _template = allData.find((t) => t.templateId === templateId);
			const _o = _template.time.find((_t) => _t.businessName === parent);
			_subAtt = _o.subAttributes.find((s) => s.businessName === panelId);
		}

		const isWalmartWeekFilterAndIsEmpty =
			filterState[index]?.parent === WALMART_CALENDAR &&
			filterState[index]?.businessName === 'Week' &&
			filterState[index]?.filter?.condition === '';
		// When the user un-selects all the filter values from Walmart calendar "week", then we reset the fitler state to default
		if (isWalmartWeekFilterAndIsEmpty) {
			newList[index] = {
				...newList[index],
				..._subAtt,
				filter: {
					condition: filterState[index].filter.condition,
					value: []
				}
			};
			delete newList[index]?.field;
		} else {
			// Edit exiting filter when user clicks on "Filter" title.
			newList[index] = {
				...newList[index],
				..._subAtt,
				filter: {
					condition: filterState[index].filter.condition,
					value: filterState[index].filter.value,
					extraValue: filterState[index].filter?.extraValue
				}
			};
		}
		const weekFilter = newList.find((item) => isCalFamily(item));
		const isMultiWeek = weekFilter ? isMultiWeekSel(weekFilter, Number(templateId)) : false;
		const field = build(newList[index], selectedView, userPersona, isMultiWeek, templateId);
		if (!isWalmartWeekFilterAndIsEmpty) {
			newList[index] = { ...newList[index], field };
		}
		/**
		 * Resets the Pivot, if applied already in the following scenarios,
		 * - When column limit exceeded,
		 * - Week filter applied is empty
		 *
		 * Also updates the isMultiWeek flag in Store.
		 */
		const DateAndWeekFilterTechNames = [
			PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_DATE,
			PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_DC_DATE,
			PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_MUMD_DATE,
			PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_ECOM_INV_DATE,
			PIVOT_SINGLE_TIME_VALUE_MAP.WMT_CAL_WEEK,
			PIVOT_SINGLE_TIME_VALUE_MAP.WMT_YEAR_AND_WEEK
		];
		if (
			hasPivotedColumn(pivotOpts?.pivotColumn) &&
			DateAndWeekFilterTechNames.includes(weekFilter?.technicalName)
		) {
			const totalCount = calculateTotalColumnCount(selectedList, newList, pivotOpts.isTimeAcross);
			if (totalCount > PIVOT_COLUMN_LIMIT || isWalmartWeekFilterAndIsEmpty) {
				dispatch(resetPivotOptions());
			}
			dispatch(setPivotOptions({ isMultiWeek }));
		}

		setFilterState(deepClone(newList));
		setPrevFilterState(deepClone(newList));

		dispatch(setFilterList(deepClone(newList)));

		// Remove Date as a column if 104 weeks (or) 12 Months (or) 4 quarters (or) Last year are selected.
		const shouldDeleteDateAsAColumn = determine104WeeksFeatureInFilter(newList[index]);
		const isDateColumnSel = selectedList?.some((column) => column.businessName === DATE_KEY);

		if (shouldDeleteDateAsAColumn && isDateColumnSel) {
			const selectedListWithoutDate = deepClone(selectedList).filter(
				(column) => column.businessName !== DATE_KEY
			);
			dispatch(setSelectedList(selectedListWithoutDate));
		}

		if (newList.length > 0) {
			dispatch(setIsMandateCheck(false));
		}
		if (!validateDimFilters(selectedList, newList, Number(templateId))) {
			dispatch(setIsMandateCheck(true));
		}
		setExpanded('');
		setValue([]);
		setLocalUsrSelection([]);
		if (fromWhere === 'editFilter') {
			cbSetShowPreviewElement('columns', true);
		}
		if (STR_TMPT_LIST.includes(Number(templateId)) && newList[index].parent === 'measures') {
			const isPresent = selectedList.some((el) => el.businessName === newList[index].businessName);
			if (!isPresent) {
				selectedList.push({ ...newList[index] });
				dispatch(addPreviewColumn(previewData, newList[index].technicalName));
			}
		}

		// If user applies filter on Variant ID then 'Item Share' toggle button will be turned on. (Charter Supplier & Catman only)
		if (
			isVariantID(Object.keys(field)[0]) &&
			customerType === CHARTER &&
			userPersona != PERSONA.MERCHANT
		) {
			dispatch(saveItemShareStatus({ curr: true }));
		}

		const isNewFilter =
			prevFilterState[index]?.filter?.value?.length === 0 &&
			filterState[index]?.filter?.value?.length > 0;
		if (isNewFilter) {
			determineIncompatibility(newList[index], -1);
		}
	};

	const updateCurrentAndPrevFilterList = (newList) => {
		setFilterState(newList);
		setPrevFilterState(newList);
	};

	const handleOnCancel = (idx) => {
		const newList = deepClone(filterState);
		const o = newList[idx];
		o.filter.condition = prevFilterState[idx].filter.condition;
		o.filter.value = [...prevFilterState[idx].filter.value];
		newList[idx] = o;
		setFilterState(newList);
		const condition = o.filter.condition;
		const value = o.filter.value;
		if (condition === FILTER_CONDITION_LABELS.IS_IN_BETWEEN) {
			if (value.length > 0) {
				value.sort((a, b) => Number(a) - Number(b));
				setRangeList({
					min: [value[0]],
					max: [value[1]]
				});
			}
		}
		setExpanded('');
		if (fromWhere === 'editFilter') {
			cbSetShowPreviewElement('columns', true);
		}
	};

	const getProToolTipText104Weeks = () => {
		return (
			<Box className={classes.tooltipPanel}>
				<Typography className={classes.tooltipText}>
					<Link
						href={`${getBaseUrl()}${isBasic ? PROTIP_LEARN_MORE_BASIC : PROTIP_LEARN_MORE}`}
						target="_blank"
						className={classes.underlineText}
						style={{ textDecoration: 'underline', color: colors.PURPLE }}>
						{LEARN_MORE}
					</Link>
					{` ${PROTIP_TEXT_104_WEEKS}`}
				</Typography>
			</Box>
		);
	};

	const getConditionField = (type, busName, parent) => {
		const isCal = isCalFamily({ dataType: type, businessName: busName });
		function getDropdownOptions(_o, forWM = false) {
			if (busName === 'Year') {
				/** Dynamic approach to have correct years */
				let curr_yr = moment().year();
				let prev_yr = moment().subtract(1, 'year').year();
				if (forWM) {
					// WM year start from week where 1st Feb lye.
					moment.locale('wm');
					const _d = moment().set('year', curr_yr).set('month', 1).set('date', 1);
					const startWkDt = _d.startOf('week');
					const currDt = moment();
					if (currDt.isBefore(startWkDt)) {
						curr_yr = prev_yr;
						prev_yr = moment().subtract(2, 'year').year();
					}
				}
				const options = _o[busName].map((option) => {
					if (option.value.includes('CURR_YR')) {
						return {
							value: option.value.replace('CURR_YR', curr_yr),
							label: option.value.replace('CURR_YR', curr_yr)
						};
					} else {
						return {
							value: option.value.replace('PREV_YR', prev_yr),
							label: option.value.replace('PREV_YR', prev_yr)
						};
					}
				});

				return options;
			}
			return _o[busName];
		}
		/**
		 * if type is date, template id = 401/403, businessname =date/week/month/quarter/year
		 */
		function getDCDateList() {
			const isWMTCal = parent?.substring(0, 3) === 'Wal';
			if (isWMTCal) {
				const { Date, Week, Month, Quarter, Year } = DCWMTCal;
				const o = { Date, Week, Month, Quarter, Year };
				return getDropdownOptions(o, true);
			}
			const { Date, Week, Month, Quarter, Year } = DCWMTCal;
			const o = { Date, Week, Month, Quarter, Year };
			// Remove Last 104 Weeks, Last 12 Months, Last 4 Quarters and WMT Last Year for gregorian calendar as they're out of scope
			remove104WeeksOptions(o);
			return getDropdownOptions(o);
		}

		function getPODateList() {
			const { poCreateDay, poShipDate, mustArriveDate, receivedDate } = POCal;
			const { wmtCalendar } = POWMTCal;
			let key = getKeyByValue(PO_DATE_LIST, busName);
			const o = { poCreateDay, poShipDate, mustArriveDate, receivedDate, wmtCalendar };
			return o[key];
		}

		function restOfTheTemplates() {
			const isWMTCal = parent?.substring(0, 3) === 'Wal';
			if (isWMTCal) {
				// Remove 104 weeks option if it isn't SSI, MUMD, Omni Sales, Ecom Inevntory, Ecom Sales or DC or Register Sales
				const isSSI = STR_TMPT_LIST.includes(Number(templateId));
				const isDC = DC_TMPT_LIST.includes(Number(templateId));
				const isMUMD = MUMD_ORDER_LIST.includes(Number(templateId));
				const isOmniSales = OMNI_TMPT_LIST.includes(Number(templateId));
				const isEcomInventory = ECOM_INVENTORY.includes(Number(templateId));
				const isEcomSales = ECOM_SALES_LIST.includes(Number(templateId));
				const isOmniOtif = OTIF_TMPT_LIST.includes(Number(templateId));
				const isRegiSales = REGISTER_SALES_LIST.includes(Number(templateId));
				const isHistoricalReport = HISTORICAL_REPORT_OMNI.includes(Number(templateId));
				let o = {};
				/**
				 * For SSI & MUMD Templates the 'WMT Last Year' option should be available for Year filter,
				 * DC Template has the option already added.
				 * And Rest of the Templates has the options available provided in the OmniWMTCal
				 */
				if (isSSI) {
					const { Date, Week, Month, Quarter, Year } = SSIWMTCal;
					o = { Date, Week, Month, Quarter, Year };
				} else if (isMUMD) {
					const { Date, Week, Month, Quarter, Year } = MUMDMTCal;
					o = { Date, Week, Month, Quarter, Year };
				} else if (isHistoricalReport) {
					const { Date, Week } = HistoricalReportOmniCal;
					o = { Date, Week };
				} else {
					const { Date, Week, Month, Quarter, Year } = OmniWMTCal;
					o = { Date, Week, Month, Quarter, Year };
				}
				if (
					!isSSI &&
					!isDC &&
					!isMUMD &&
					!isOmniSales &&
					!isEcomInventory &&
					!isEcomSales &&
					!isRegiSales &&
					!isHistoricalReport
				) {
					// Remove Last 104 Weeks, Last 12 Months, Last 4 Quarters and WMT Last Year
					remove104WeeksOptions(o);
				}
				/** For OTIF - Need to remove Y'day and weekend.
				 * For MUMD, ECOM - Need to remove weekend only.
				 */
				/** Not filtering options for STR_TMPT_LIST templates REF:DSIDVL-36753 */
				if (busName === 'Date' && !isSSI) {
					let optionToRemove = [];
					const { YESTERDAY, WEEKEND, WMT_WEEK_TO_DATE, WMT_LAST_WEEK } = FILTER_CONDITION_LABELS;
					if (isOmniOtif) {
						optionToRemove = [YESTERDAY, WEEKEND, WMT_WEEK_TO_DATE, WMT_LAST_WEEK];
					}
					if (
						[...MUMD_ORDER_LIST, ...ECOM_INVENTORY, ...ECOM_SALES_LIST].includes(Number(templateId))
					) {
						optionToRemove = [WEEKEND];
					}
					const _o = o[busName].filter((el) => !optionToRemove.includes(el.label));
					return _o;
				}
				return getDropdownOptions(o, true);
			}
			const { Date, Week, Month, Quarter, Year } = OmniStdCal;
			const o = { Date, Week, Month, Quarter, Year };
			/** For OTIF - Need to remove options which are less than of 2 weeks period. */
			if (['Date', 'Week'].includes(busName)) {
				if (OTIF_TMPT_LIST.includes(Number(templateId))) {
					const { YESTERDAY, WEEK_TO_DATE, LAST_WEEK } = FILTER_CONDITION_LABELS;
					let optionToRemove = [YESTERDAY, WEEK_TO_DATE, LAST_WEEK];
					const _o = o[busName].filter((el) => !optionToRemove.includes(el.label));
					return _o;
				}
			}
			return getDropdownOptions(o);
		}

		function getStrDemandDateList() {
			const { Week } = StoreDemandCal;
			const o = { Week };
			if (customerType === BASIC) {
				const basicFilterList = o.Week.filter((el) =>
					[FILTER_CONDITION_LABELS.WMT_CURR_WK].includes(el.label)
				);
				return basicFilterList;
			}
			return o[busName];
		}

		function getStrOrderDateList() {
			const { Week } = StoreOrderCal;
			const o = { Week };
			if (customerType === BASIC) {
				const basicFilterList = o.Week.filter(
					(el) => ![FILTER_CONDITION_LABELS.CUSTOM].includes(el.label)
				);
				return basicFilterList;
			}
			return o[busName];
		}

		const templateIdNum = Number(templateId);
		const isCustomDS = isCustomDataset(templateId);

		// If selected template id is 509 (Mod template for merchant) then don't show is not null condition for any field
		let menuItem = [];
		if (CANNED_REPORT_LIST.includes(Number(templateId))) {
			menuItem = [...EqualsToCondition];
		} else if (type === 'number') {
			if (parent === 'measures') {
				const newNumCondition = NumberCondition.slice(0, -2);
				menuItem = [...newNumCondition];
			} else if (templateId === '509') {
				const newNumCondition = NumberCondition.slice(0, -1);
				menuItem = [...newNumCondition];
			} else if (
				(STR_TMPT_LIST.includes(Number(templateId)) || isCustomDS) &&
				busName === TRAIT_NUMBER
			) {
				menuItem = [...TraitNumberConditions];
			} else if (['Trait Number', 'Trait Description'].includes(busName)) {
				// for store trait
				menuItem = [...EqualsToConditionOnly];
			} else {
				menuItem = [...NumberCondition];
			}
		} else if (isCal) {
			const strDemandList = [...STR_DEMAND_LIST];
			const strOrderList = [...STR_ORDER_LIST];
			if (strDemandList.includes(templateIdNum)) {
				menuItem = [...getStrDemandDateList()];
			} else if (strOrderList.includes(templateIdNum)) {
				menuItem = [...getStrOrderDateList()];
			} else if (DC_TMPT_LIST.includes(templateIdNum)) {
				menuItem = [...getDCDateList()];
			} else if (PURCHASE_ORDER_LIST.includes(templateIdNum)) {
				menuItem = [...getPODateList()];
			} else {
				menuItem = [...restOfTheTemplates()];
			}
		} else if (type === 'string') {
			if (parent === 'measures') {
				const newStringCondition = StringCondition.slice(0, -2);
				menuItem = [...newStringCondition];
			} else if (templateId === '509') {
				const newStringCondition = StringCondition.slice(0, -1);
				menuItem = [...newStringCondition];
			} else if (
				STR_TMPT_LIST.includes(Number(templateId)) &&
				SSIContainsOnlyColumns.includes(busName)
			) {
				menuItem = [...ContainsConditionOnly];
			} else if (['Trait Number', 'Trait Description'].includes(busName)) {
				// for store trait
				menuItem = [...EqualsToConditionOnly];
			} else {
				menuItem = [...StringCondition];
			}
		} else if (busName === WM_YR_WK_NO) {
			/** WK Demand Dimension*/
			menuItem = [...demandFrcstWkCal];
		} else if (
			STR_ORDER_LIST.includes(Number(templateId)) &&
			STR_ORDER_FIELDS_WITH_FUZZY.includes(busName)
		) {
			/** Order Forecast template has 4 fields with fuzzy options */
			menuItem = [...orderFrcstWkCal];
		} else if (['dimensions', 'measures'].includes(parent) && type === 'date') {
			menuItem = [...otherDtConditions];
		} else {
			menuItem = [...customDtCondition];
		}

		return menuItem.map((el, index) => (
			<MenuItem
				key={index}
				value={el.value}
				name={el.value}
				className={classes.fontStyle}
				disabled={el.charterOnly}>
				<Box display="flex" alignItems="center">
					<ListItemText primary={el.label} />
					{el.value === wmtLastOneHundredAndFourWeeks && (
						<Box>
							<Tooltip
								title={getProToolTipText104Weeks()}
								arrow
								style={{ maxWidth: '100px' }}
								leaveDelay={3000}
								placement="top"
								clickable>
								<InfoOutlinedIcon
									style={{ color: '#6D6E71', marginTop: '4px', marginLeft: '4px' }}
									fontSize="small"
								/>
							</Tooltip>
						</Box>
					)}
					{el.charterOnly && (
						<Typography className={classes.charterOnlyText}>Charter only</Typography>
					)}
				</Box>
			</MenuItem>
		));
	};

	const disableSave = (index) => {
		const lFilterState = filterState[index];
		const lPrevFilterState = prevFilterState[index];
		const {
			businessName: lBussName,
			filter: { condition: lCondition, value: lValue }
		} = lFilterState;
		const {
			businessName: pBussName,
			filter: { condition: pCondition, value: pValue }
		} = lPrevFilterState;

		if (lPrevFilterState === undefined || lFilterState === undefined) {
			return true;
		}

		if (shouldShowRangeInput(lCondition)) {
			if (lValue.length < 2) {
				return true;
			}
			if (Number(rangeList.min[0]) > Number(rangeList.max[0])) {
				return true;
			}
			// compare prev and current range
			lValue.sort((a, b) => Number(a) - Number(b));
			pValue.sort((a, b) => Number(a) - Number(b));
			if (_isEqual(lValue, pValue)) {
				return true;
			}
		}

		if (isNullField(lCondition)) {
			if (pCondition === lCondition) {
				return true;
			}
			return false;
		}

		if (value.length === 0 && lValue.length === 0) {
			return true;
		}

		if (lBussName === pBussName && pCondition === lCondition && _isEqual(pValue, lValue)) {
			return true;
		}
		return false;
	};

	/**
	 * if there is no change in previous and new selection
	 */
	const disableCancel = (idx) => {
		if (!compareObj(prevFilterState[idx], filterState[idx])) {
			return false;
		}
		return disableSave(idx);
	};

	async function fetchOptions(item) {
		if (sbuDBTechNames.includes(item.dbtechnicalName)) {
			setOptions(sbuDepartments);
			setFilterValueReadOnly(true);
			return;
		}
		setFilterValueReadOnly(false);

		/** EI template */
		if (item.technicalName === 'snap_shot_hour') {
			let options = Array.from({ length: 24 }, (_, i) => i + 1);
			setOptions(options);
			return;
		}

		if (loading || !item.filterValuesFlag) {
			return;
		}
		const { dbtechnicalName, dataType } = item;
		const request = { companyName, loginId };
		const { headers } = getAuthHeader(request);

		let url = '';
		if (item.parent === PARENT_CUST_ATTR) {
			url = `${APIURLPATH.CUSTOM_ATTRIBUTES}${item.businessName}?type=${userPersona}&businessName=${item.businessName}`;
		} else {
			url = `${APIURLPATH.FILTER_VALUES}${dbtechnicalName.toLowerCase()}?type=${userPersona}`;
		}
		setLoading(true);
		try {
			const optionsJson = await fetch(url, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					...headers
				}
			});
			let options = await optionsJson.json();
			if (optionsJson?.status >= 400) {
				setOptions([]);

				if (optionsJson?.status === BLOCKED_STATUS_CODE) {
					// Analytics
					trackEventInfo({
						type: EVENTS.BOT_DETECTION,
						actionOn: ACTION_ON.BOT_DETECTION,
						location: PAGE_ID.PREVIEW
					});
					setPXProperties(options);
					setShowCaptchaDialogBox(true);
				}
			} else {
				if (dataType === 'number') {
					options = options.map((option) => (Number(option) < 10 ? `0${option}` : option));
				}
				setOptions(options);
			}

			setLoading(false);
		} catch (error) {
			setLoading(false);
		}
	}

	const handleConditionChange = (event, index) => {
		event.stopPropagation();
		const newList = deepClone(filterState);
		newList[index].filter.condition = event.target.value;
		newList[index].filter.value = [];
		setFilterState(newList);
		setValue([]);
		setRangeList({ min: [], max: [] });
		setIsConditionChanged(true);
	};

	const handlePreviewTableCol = (item) => {
		const lSelectedList = deepClone(selectedList);
		const indexToRemove = [];
		lSelectedList.forEach((el, index) => {
			if (isCalFamily(el)) {
				// We need to set indecies in the reverse order to easily remove extra cal family selections from selected list
				indexToRemove.unshift(index);
				dispatch(removePreviewColumn(previewData, el.technicalName));
			}
		});
		indexToRemove.forEach((idx) => lSelectedList.splice(idx, 1));
		const currentIndex = lSelectedList.findIndex((el) => {
			return el.businessName === item.businessName;
		});
		if (currentIndex === -1) {
			lSelectedList.unshift(item);
			dispatch(addPreviewColumn(previewData, item.technicalName));
		}
		dispatch(setSelectedList(deepClone(lSelectedList)));
	};

	const setMultipleTimeFilterCondition = (condition, list, index, isWMTCal) => {
		setIsConditionChanged(false);
		if (condition.length === 0 || (condition.length === 1 && condition[0] === '')) {
			return list;
		}
		setmultiCondition(condition);
		// If in multi time selection, only 1 time range is selected then we need to follow the single time range selection
		if (condition.length === 1) {
			const filteredFuzzyOption = getStartAndEndDates(
				condition[0],
				getFuzzyOptions(),
				isWMTCal,
				calendarRollDim
			);
			const lValue = getDateRange(condition[0], false, isWMTCal);
			list[index].filter.condition = condition.join(',');
			list[index].filter.value = lValue;
			if (filteredFuzzyOption?.weekStartDate && filteredFuzzyOption?.weekEndDate) {
				list[index].filter.extraValue = [
					moment(filteredFuzzyOption?.weekStartDate).format(dateFormat),
					moment(filteredFuzzyOption?.weekEndDate).format(dateFormat)
				];
			}
			setValue(lValue);
			return list;
		}

		condition = condition.filter((con) => con !== selectAll);
		const values = [];
		condition.map((o) => {
			values.push(getMutlipleDateRange(o));
		});

		list[index].filter.condition = condition.join(',');
		list[index].filter.value = values;
		list[index].filter.extraValue = values;
		handlePreviewTableCol(list[index]);
		setValue(values);

		return list;
	};

	const handleDateChange = (event, index, isWMTCal) => {
		if (event.target) {
			event.stopPropagation();
		}
		setIsConditionChanged(false);
		let condition = event?.target ? event?.target?.value : event;
		let newList = deepClone(filterState);
		newList[index].filter.condition = condition;
		/**
		 * | Handle multi time selection
		 */
		if (isMultiTimeFilterEnabled(newList[index], Number(templateId))) {
			setIsMultiFilter(true);
			condition = typeof condition === 'string' ? condition.split(',') : condition;
			if (condition.includes('Custom') && !multiCondition.includes('Custom')) {
				/**
				 * Handle custom filter
				 */
				condition = 'Custom';
				setmultiCondition([condition]);
				newList[index].filter.condition = condition;
				newList[index].filter.value = [];
				setValue([]);
			} else {
				newList = setMultipleTimeFilterCondition(condition, newList, index, isWMTCal);
			}
		} else if (hideDateRangeInput(newList[index])) {
			// All predefined fuzzy options should go here.
			const filteredFuzzyOption = getStartAndEndDates(
				condition,
				getFuzzyOptions(),
				isWMTCal,
				calendarRollDim
			);
			const lValue = getDateRange(condition, false, isWMTCal);
			newList[index].filter.value = lValue;
			newList[index].filter.extraValue = [
				moment(filteredFuzzyOption?.weekStartDate).format(dateFormat),
				moment(filteredFuzzyOption?.weekEndDate).format(dateFormat)
			];
			setValue(lValue);
		} else {
			newList[index].filter.value = [];
			setValue([]);
		}
		setFilterState(newList);
	};

	const handleOnPaste = (event, index, dataType) => {
		const newList = deepClone(filterState);

		/* if values are already present, then need to get length */
		// const len = newList[index].filter.value.length;

		const newStr = event.clipboardData.getData('Text');
		if (!newStr || newStr.trim() === '') {
			return;
		}
		event.preventDefault();

		let regex = /[\n\t]+/;
		if (dataType === 'number') {
			regex = /[,\n\t]+/;
		}

		let strList = newStr
			.split(regex)
			.map((el) => el.trim())
			.filter((el) => el.length > 0);
		// .slice(0, 200 - len);

		if (sbuDBTechNames.includes(newList[index].dbtechnicalName)) {
			return;
		}
		for (let item of strList) {
			const isNumber = Number.isInteger(Number(item));
			let maxValuesAllowed = MAX_FILTER_VALUE;

			const isCustomDS = isCustomDataset(templateId);
			if (
				(STR_TMPT_LIST.includes(Number(templateId)) || isCustomDS) &&
				['trait_description'].includes(newList[index].technicalName)
			) {
				maxValuesAllowed = SSI_STORE_TRAIT_ATTRS.MAX_FILTER_VALUE;
			} else if (dataType === 'number') {
				maxValuesAllowed =
					(STR_TMPT_LIST.includes(Number(templateId)) || isCustomDS) &&
					['trait_number'].includes(newList[index].technicalName)
						? SSI_STORE_TRAIT_ATTRS.MAX_FILTER_VALUE
						: MAX_INT_FILTER_VALUE;
				if (!isNumber) {
					return;
				}
				item = `${Number(item)}`;
			}
			if (newList[index].filter.value.length === maxValuesAllowed) {
				break;
			}
			// Duplicates not allowed
			if (!newList[index].filter.value.includes(item)) {
				newList[index].filter.value = [...newList[index].filter.value, item];
			}
		}
		setFilterState(deepClone(newList));
		setValue([...newList[index].filter.value]);
	};

	const handleAddChip = (event, index, list = []) => {
		if (event) {
			event.stopPropagation();
			if (filterValueReadOnly) {
				event.preventDefault();
			}

			let keyPreventList = [','];

			if (filterState[index].dataType === 'number') {
				keyPreventList = [',', 'e'];
			}

			if (keyPreventList.includes(event.key)) {
				event.preventDefault();
			}
		}
		const newList = deepClone(filterState);
		// Duplicates not allowed
		const uniqueList = [...new Set(list)];
		newList[index].filter.value = uniqueList;
		setFilterState(deepClone(newList));
		setValue([...newList[index].filter.value]);
	};

	const handleChipDelete = (newFilteredList, index) => {
		const newList = deepClone(filterState);
		newList[index].filter.value = [...newFilteredList];
		setFilterState(newList);
		setValue(newFilteredList);
	};

	const handleOnDelete = (idx) => {
		const newList = deepClone(filterState);
		const removedFilter = newList.splice(idx, 1);
		setFilterState(newList);
		setLocalUsrSelection([]);
		dispatch(setFilterList(newList));
		if (fromWhere === 'editFilter') {
			cbSetShowPreviewElement('columns', true);
		}
		// Any number other than -1 indicates the filter has been removed.
		determineIncompatibility(removedFilter[0], 1);
	};

	const getDefaultFilterData = () => {
		const customDatasetsWithTime = getSavedCustomDatasetWithAttributes(
			savedCustomDatasets,
			customDatasetDetails,
			customAttribute
		);
		const allData = [...templateData, ...cannedReportData, ...customDatasetsWithTime];
		const result = allData.filter(
			(item) => item.templateName === getTmplName(templateId) || item.customDatasetId === templateId
		);
		return getDfltFilter(result);
	};

	const handleClearAllFilter = () => {
		setmultiCondition([]);
		const customDatasetsWithTime = getSavedCustomDatasetWithAttributes(
			savedCustomDatasets,
			customDatasetDetails,
			customAttribute
		);
		const allData = [...templateData, ...cannedReportData, ...customDatasetsWithTime];
		const result = allData.filter(
			(item) => item.templateName === getTmplName(templateId) || item.customDatasetId === templateId
		);

		let list = getDfltFilter(result);
		let sbuList = [];
		let modList = [];

		/**
		 * | If SBU is present then we need to build a field for the default condition
		 * | LIMITED MERCHANT ACCESS
		 */
		const SBUDfltCondition = FILTER_CONDITION_LABELS.IS_EQUAL_TO;
		if (userPersona === 'MERCHANT' && !blackOut) {
			const SBUdimension = result[0].dimensions.filter((dim) =>
				sbuDBTechNames.includes(dim.dbtechnicalName)
			);

			const dfltFiltersOnDimensions = [];
			SBUdimension.map((dim) => {
				dfltFiltersOnDimensions.push({
					dimension: dim,
					condition: SBUDfltCondition,
					value: sbuDepartments.map((dept) => dept.deptNum)
				});
			});
			sbuList = getDfltFilter(result, dfltFiltersOnDimensions, false);
			sbuList.map((filter, index) => {
				if (sbuDBTechNames.includes(filter.dbtechnicalName)) {
					const field = build(sbuList[index], selectedView, userPersona, false, templateId);
					sbuList[index] = { ...sbuList[index], field };
				}
			});
		}
		// TODO: need to refactor after Mid May release
		if (MOD_TMPT_LIST.includes(Number(templateId))) {
			const dimToBeFiltered = result[0].dimensions.filter(
				(dim) => dim.technicalName === 'store_item_valid_ind'
			);
			const dfltFiltersOnDimensions = [];
			dimToBeFiltered.map((dim) => {
				dfltFiltersOnDimensions.push({
					dimension: dim,
					condition: SBUDfltCondition,
					value: ['1']
				});
			});
			modList = getDfltFilter(result, dfltFiltersOnDimensions, false);

			modList.map((filter, index) => {
				if (filter.technicalName === 'store_item_valid_ind') {
					const field = build(modList[index], selectedView, userPersona, false, templateId);
					modList[index] = { ...modList[index], field };
				}
			});
		}

		list = [...list, ...sbuList, ...modList];
		setFilterState(deepClone(list));
		setPrevFilterState(deepClone(list));
		dispatch(setFilterList(list));
		dispatch(setPrevFilterList(list));
		dispatch(clearPreview([]));
	};

	const ShowDeleteBtn = (o, index) => {
		return (
			<IconButton
				aria-label={`Remove ${o.businessName}`}
				id={`Remove-${o?.businessName?.split(' ').join('-')}`}
				size="small"
				style={{ right: 4, padding: 8 }}
				onClick={(e) => {
					e.stopPropagation();
					handleOnDelete(index);
				}}>
				<DeleteOutlineIcon style={{ fontSize: '16px' }} />
			</IconButton>
		);
	};

	const handlePasteMinChip = (event, index, dataType) => {
		const newStr = event.clipboardData.getData('Text');
		if (newStr.trim() === '') {
			return;
		}
		event.preventDefault();

		const strList = newStr.split(',');
		if (strList.length > 1) {
			return;
		}

		if (rangeList.min.length === 0) {
			handleOnPaste(event, index, dataType);
			setRangeList({ ...rangeList, min: [newStr] });
		}
	};

	const handlePasteMaxChip = (event, index, dataType) => {
		const newStr = event.clipboardData.getData('Text');
		if (newStr.trim() === '') {
			return;
		}
		event.preventDefault();

		const strList = newStr.split(',');
		if (strList.length > 1) {
			return;
		}

		if (rangeList.max.length === 0) {
			handleOnPaste(event, index, dataType);
			setRangeList({ ...rangeList, max: [newStr] });
		}
	};

	const handleMinChip = (event, index, list) => {
		event.stopPropagation();

		if ([',', 'e'].includes(event.key)) {
			event.preventDefault();
		}

		// if (rangeList.min.length === 0) {
		const newList = deepClone(filterState);
		if (newList[index].filter.value.length > 1) {
			newList[index].filter.value.sort();
			newList[index].filter.value.shift();
		}
		const uniqueList = [...new Set([...list, ...newList[index].filter.value])];
		newList[index].filter.value = uniqueList;
		setFilterState(deepClone(newList));
		setValue([...newList[index].filter.value]);
		setRangeList({ ...rangeList, min: list });
		// }
	};

	const handleMaxChip = (event, index, list) => {
		if ([',', 'e'].includes(event.key)) {
			event.preventDefault();
		}

		// if (rangeList.max.length === 0) {
		const newList = deepClone(filterState);
		if (newList[index].filter.value.length > 1) {
			newList[index].filter.value.sort();
			newList[index].filter.value.pop();
		}
		const uniqueList = [...new Set([...newList[index].filter.value, ...list])];
		newList[index].filter.value = uniqueList;
		setFilterState(deepClone(newList));
		setValue([...newList[index].filter.value]);
		setRangeList({ ...rangeList, max: list });
		// }
	};

	const handleDeleteMinChip = (item, index) => {
		const newList = deepClone(filterState);
		const v = newList[index].filter.value[1];
		/**
		 * below logic to check if max deleted before the min.
		 * if max deleted - then index at 1 would be undefined.
		 */
		if (v !== undefined) {
			newList[index].filter.value = [v];
		} else {
			newList[index].filter.value = [];
		}
		// newList[index].filter.value = [newList[index].filter.value[1]];
		handleChipDelete(newList[index].filter.value, index);
		setRangeList({ ...rangeList, min: [] });
	};

	const handleDeleteMaxChip = (item, index) => {
		const newList = deepClone(filterState);
		newList[index].filter.value = [newList[index].filter.value[0]];
		handleChipDelete(newList[index].filter.value, index);
		setRangeList({ ...rangeList, max: [] });
	};

	const handleSetDateRange = (selection, index) => {
		const { start, end, week1, week2 } = selection;
		if ([start, end].includes(undefined)) {
			return;
		}
		const newList = deepClone(filterState);
		newList[index].filter.value = [start.format('YYYY/MM/DD'), end.format('YYYY/MM/DD')];
		newList[index].filter.extraValue = [week1, week2];
		setFilterState(deepClone(newList));
		setValue([...newList[index].filter.value]);
	};

	function handleTourCallback(data) {
		const { action, type } = data;
		if (action === 'skip' || type === 'tour:end') {
			localStorage.setItem('FilterFormTourSkip', true);
			setRunTour(false);
		}
	}

	function handleDateFilterChange(o, index) {
		setmultiCondition([]);

		const filterList = deepClone(filterState);
		filterList.splice(index, 1);
		filterList.unshift({ ...o.attr, parent: o.parent, filter: { condition: '', value: [] } });

		const prevFilterList = deepClone(prevFilterState);
		prevFilterList.splice(index, 1);
		prevFilterList.unshift({ ...o.attr, parent: o.parent, filter: { condition: '', value: [] } });

		// if it is MTS, update the filter list in redux because having this filter in redux
		// is pre-requisite in all the MTS components
		if (o?.attr?.localName === MULTI_TIME_SELECTION) {
			// Opens MTS input field
			dispatch(setIsMTSFilterCollapsed(false));
			dispatch(setFilterList(filterList));
		}
		setFilterState(filterList);
		setPrevFilterState(prevFilterList);
		setExpanded(o.attr.businessName);
	}

	const showFilterSelection = (o, idx) => {
		const {
			filter: { condition, value }
		} = prevFilterState[idx];
		let filterVal = [];

		/** If value[0] is equal to value[1], then take zeroth index only
		 * this will help for 'on', 'after' and 'before' case
		 */
		if (value.length > 0) {
			filterVal = value[0] !== value[1] ? value.join(',') : value[0];
		}

		const showValues = () => {
			if (filterVal.length === 0) {
				return false;
			}

			if (isCalFamily(o) && condition !== 'Custom') {
				return false;
			}
			return true;
		};
		return (
			<>
				<span style={{ fontWeight: 400, color: '#333333' }}>{condition}</span>
				{showValues() && <span style={{ fontStyle: 'italic' }}>{`: ${filterVal}`}</span>}
			</>
		);
	};

	const showTimeLagMsg = () => {
		if (OTIF_TMPT_LIST.includes(Number(templateId))) {
			return <Typography className={classes.timeLag}>{TIME_LAG}</Typography>;
		}

		return null;
	};

	const ShowRangeInput = ({ item, index }) => {
		if (!shouldShowRangeInput(item.filter.condition)) {
			return null;
		}
		const getMaxInputLenAllowed = () => {
			let maxValuesAllowed = getInputLenAllowed(item.filter.condition);
			const isCustomDS = isCustomDataset(templateId);
			if (
				(STR_TMPT_LIST.includes(Number(templateId)) || isCustomDS) &&
				['trait_number', 'trait_description'].includes(item.technicalName)
			) {
				maxValuesAllowed = SSI_STORE_TRAIT_ATTRS.MAX_FILTER_VALUE;
			} else if (item.dataType === 'number') {
				maxValuesAllowed = MAX_INT_FILTER_VALUE;
			}
			return maxValuesAllowed;
		};
		return (
			<FormControl
				variant="outlined"
				style={{
					display: 'flex',
					flexDirection: 'row',
					marginLeft: 16,
					marginRight: 16,
					alignItems: 'center'
				}}>
				<ChipInput
					cbHandleAddChip={handleMinChip}
					cbHandleChipDelete={handleDeleteMinChip}
					condition={item.filter.condition}
					value={rangeList.min}
					dataType={item.dataType}
					index={index}
					customCssStyle={{ width: '80%' }}
					placeholder={'min'}
					cbHandleOnPaste={handlePasteMinChip}
					chipLen={getMaxInputLenAllowed()}
					item={item}
					busName={item.businessName}
					showExpanded={(condition, val, index, busName) => {
						setShowExpandedFilter(true);
						setFilterObj({
							busName: busName,
							condition: condition,
							val: val,
							index: index
						});
					}}
				/>
				<Typography style={{ margin: 10 }}>and</Typography>

				<ChipInput
					cbHandleAddChip={handleMaxChip}
					cbHandleChipDelete={handleDeleteMaxChip}
					condition={item.filter.condition}
					value={rangeList.max}
					dataType={item.dataType}
					index={index}
					customCssStyle={{ width: '80%' }}
					placeholder={'max'}
					cbHandleOnPaste={handlePasteMaxChip}
					chipLen={getMaxInputLenAllowed()}
					item={item}
					busName={item.businessName}
					showExpanded={(condition, val, index, busName) => {
						setShowExpandedFilter(true);
						setFilterObj({
							busName: busName,
							condition: condition,
							val: val,
							index: index
						});
					}}
				/>
			</FormControl>
		);
	};

	function getBussName(businessName, tmpltId, isCal) {
		let appliedBussName = businessName;
		const WK_SPEC_TMPT = [...STR_TMPT_LIST, ...DC_TMPT_LIST];
		if (WK_SPEC_TMPT.includes(tmpltId) && isCal) {
			const timeFilterObj = selectedList.find(
				(el) => el.businessName === businessName && isCalFamily(el)
			);
			if (timeFilterObj !== undefined) {
				appliedBussName = timeFilterObj.businessName;
			}
		}

		const newBussName = buildBusinessName(appliedBussName, tmpltId);
		return {
			newBussName,
			businessName: appliedBussName
		};
	}

	const showPlaceHolder = (o) => {
		const { START_TYPING, VALUES, LOADING_SUGGESTION } = PLACEHOLDER_TXT;
		if (o.filterValuesSearchCall) {
			return START_TYPING;
		}

		if (loading) {
			return LOADING_SUGGESTION;
		}

		return VALUES;
	};

	const getDataInUse = () => {
		const getIcon = (item) => {
			const icnList = {
				date: dateIcon,
				number: integerIcon,
				string: textIcon,
				time: accessTime
			};
			return icnList[item.dataType];
		};
		const showFilterIcon = (item) => {
			return filterState.some(
				(filter) => filter.field && filter.businessName === item.businessName
			);
		};

		const shouldDisableFilter = (item) => {
			if (isCalFamily(item)) {
				return filterState.findIndex((item) => isCalFamily(item) && item.field) > -1;
			}

			if (!enableFilter(item, templateId, item.parent)) {
				return true;
			}

			return false;
		};

		let list = selectedList;
		if (CANNED_REPORT_LIST.includes(Number(templateId))) {
			list = [];
			cannedReportData
				.filter((item) => item.templateName === getTmplName(templateId))[0]
				.dimensions.forEach((item) => list.push({ ...item, parent: 'dimensions' }));
		}

		const menu = list.map((item) => {
			return (
				<MenuItem
					disabled={shouldDisableFilter(item)}
					className={classes.dataInUseMenuItem}
					key={item.businessName}
					id={item.businessName.split(' ').join('-')}
					onClick={() => {
						setLocalUsrSelection([item]);
						setAddFilterAnchorEl(null);
					}}>
					<ListItemIcon style={{ minWidth: '20px' }}>
						<img src={getIcon(item)} style={{ marginRight: '8px' }} />
					</ListItemIcon>
					<ListItemText>{item.businessName}</ListItemText>
					{showFilterIcon(item) && (
						<ListItemIcon style={{ minWidth: '20px' }}>
							<FilterListIcon style={{ fontSize: '16px' }} />
						</ListItemIcon>
					)}
				</MenuItem>
			);
		});
		if (menu.length > 0) {
			menu.sort((a, b) => {
				if (a.key && b.key) {
					return a.key.localeCompare(b.key);
				}
			});
		}
		if (fromWhere !== 'quickReport') {
			menu.push(<Divider />);
			menu.push(
				<MenuItem
					key="selectFromAll"
					onClick={() => cbSetShowPreviewElement(FILTER_LOWER, true, true)}>
					<ListItemText className={classes.dataInUseMenuItem}>{SELECT_FROM_ALL}</ListItemText>
					<ListItemIcon style={{ minWidth: '20px' }}>
						<ChevronRightIcon style={{ fontSize: '16px' }} />
					</ListItemIcon>
				</MenuItem>
			);
		}
		menu.unshift(
			<MenuItem className={classes.dataInUseMenuHeader} key="dataInUseHeader">
				<ListItemText>{DATA_IN_USE}</ListItemText>
			</MenuItem>
		);
		return menu;
	};

	const ShowFilterForm = ({ list }) => {
		return list?.map((listItem, idx) => {
			const { item, index } = listItem;
			const { dbtechnicalName, businessName, dataType, parent, technicalName } = item;
			const printParentName =
				listTypes.includes(parent) || specificTmplList.includes(Number(templateId)) ? '' : parent;
			const showNoFilter = expanded !== businessName && item.field === undefined;
			const showFilterSel = expanded !== businessName && item.field !== undefined;
			const isCal = isCalFamily(item);
			const isDfltFilter = isDefaultFilter(item, selectedList, sbuDBTechNames, templateId);
			const hideInputValInput = hideValueInput(item.filter.condition, item.dataType);
			const shouldDisableCondition = () => sbuDBTechNames.includes(dbtechnicalName);
			let values = item.filter.value;
			if (sbuDBTechNames.includes(dbtechnicalName)) {
				values = sbuDepartments.filter((dept) => item.filter.value.includes(dept.deptNum));
			}

			const lBussName = getBussName(businessName, Number(templateId), isCal);
			const getIsMultiTimeFilter = () => isMultiTimeFilterEnabled(item, Number(templateId));

			const maxValuesAllowedFn = () => {
				let maxValuesAllowed = getInputLenAllowed(item.filter.condition);
				const isCustomDS = isCustomDataset(templateId);

				if (
					(STR_TMPT_LIST.includes(Number(templateId)) || isCustomDS) &&
					['trait_number', 'trait_description'].includes(technicalName)
				) {
					maxValuesAllowed = SSI_STORE_TRAIT_ATTRS.MAX_FILTER_VALUE;
				} else if (dataType === 'number') {
					maxValuesAllowed = MAX_INT_FILTER_VALUE;
				}
				return maxValuesAllowed;
			};

			/* Condition for WMT calendar flag updated as per PO Changes */
			const isWMTCal = ['Wal'].includes(parent?.substring(0, 3)) || parent === '';

			const maxValuesAllowed = maxValuesAllowedFn();
			const getFilterValueCount = () => {
				if (values.length <= maxValuesAllowed) {
					return (
						<Box className={classes.warnMsg}>
							<Typography className={classes.warnMsg}>
								{values.length} / {maxValuesAllowed}
							</Typography>
						</Box>
					);
				} else {
					return (
						<Box className={classes.errorMsg}>
							<ErrorOutlineIcon style={{ fontSize: '16px' }} />
							<Typography className={classes.errorMsg}>
								{values.length} / {maxValuesAllowed} {EXCEED_MAX_LIMIT}
							</Typography>
						</Box>
					);
				}
			};

			/* 
				Function returns advance option to be displayed for dimension/metric 
				on filter screen 
			*/
			const showAdvanceOption = () => {
				/* 
					Returns null when the respective dimension/metric is 
					not present in the array of list 'SHOW_ADVANCED_OPTIONS_LIST'
					or if it is CDS
				*/
				const condition = item.filter.condition === '';
				if (!SHOW_ADVANCED_OPTIONS_LIST.includes(item.businessName)) return null;
				return (
					<Box
						id="advanced-visual-hierarchy"
						className={condition ? classes.disabledAdvanceLink : classes.advanceLink}
						onClick={() => {
							if (condition) return;
							setShowVHWidget(true);
						}}>
						{ADVANCED_OPTIONS}
					</Box>
				);
			};

			if (item?.localName === MULTI_TIME_SELECTION) {
				return (
					<MultiTimeSelectionFilter
						mtsState={mtsState}
						selectedView={selectedView}
						userPersona={userPersona}
						onMTSUpdate={onMTSUpdate}
						templateId={templateId}
						key={index}
						parentPanel={fromWhere}
						onInputClick={() => setShowMTSWidget(!showMTSWidget)}
						goBack={() => cbSetShowPreviewElement('columns', true)}
						updateCurrentAndPrevFilterList={updateCurrentAndPrevFilterList}
					/>
				);
			} else {
				const is104FeatureSelected = determine104WeeksFeatureInFilterList(filterState);
				return (
					<>
						<Accordion
							key={index}
							className={classes.accordianContainer}
							id={`accordian-${index}`}
							expanded={expanded === businessName}
							onChange={() => handleAccordianExpand(businessName, item)}>
							<StyledAccordionSummary className={classes.accordianSummary}>
								<Box style={{ display: 'flex', alignItems: 'center' }}>
									<Tooltip
										title={`${printParentName} ${lBussName.newBussName}`}
										placement={'bottom'}>
										<InputLabel
											id={`show-business-name-${index}`}
											style={{ width: drawerWidth - 75 }}
											className={classes.businessName}>
											{`${printParentName} ${lBussName.newBussName}`}
										</InputLabel>
									</Tooltip>

									{fromWhere !== 'editFilter' && isCal && expanded === businessName && (
										<ShowDateElements
											cbHandleDateFilterChange={(item) => handleDateFilterChange(item, index)}
											filter={filterState}
											mtsSubAttr={mtsSubAttr}
										/>
									)}

									{!isDfltFilter && ShowDeleteBtn(item, index)}
								</Box>
								{showNoFilter && (
									<InputLabel id="no-filter-applied" className={classes.noFilterLbl}>
										{SELECT_VALUE}
									</InputLabel>
								)}

								{showFilterSel && (
									<Box className={classes.appliedFilter}>
										<InputLabel id="no-filter-applied" className={classes.noFilterLbl}>
											{showFilterSelection(item, index)}
										</InputLabel>
									</Box>
								)}
							</StyledAccordionSummary>
							<Box className={classes.selection}>
								<FormControl
									variant="outlined"
									className={classes.formControl}
									disabled={loading || shouldDisableCondition()}>
									<InputLabel className={classes.fontStyle} id="condition-lbl">
										{FORM_SEL_CONDITION_LBL}
									</InputLabel>
									{getIsMultiTimeFilter() ? (
										<MultiSelectInputCondition
											condition={item.filter.condition}
											cbHandleSelInpConChg={(pTime) => handleDateChange(pTime, index, isWMTCal)}
											customClass={classes.fontStyle}
											isMultiFilter={isMultiFilter}
											setIsMultiFilter={setIsMultiFilter}
										/>
									) : (
										<Select
											value={item.filter.condition}
											onChange={(event) =>
												dataType === 'date'
													? handleDateChange(event, index, isWMTCal)
													: handleConditionChange(event, index)
											}
											label={FORM_SEL_CONDITION_LBL}
											className={classes.fontStyle}
											renderValue={(selected) => selected}
											id="select-input">
											{getConditionField(dataType, lBussName.businessName, parent)}
										</Select>
									)}
									{isCal && showTimeLagMsg()}
								</FormControl>

								{!hideInputValInput && (
									<FormControl variant="outlined" className={classes.formControl}>
										<ChipInput
											cbHandleAddChip={handleAddChip}
											cbHandleChipDelete={handleChipDelete}
											condition={item.filter.condition}
											value={values}
											dataType={item.dataType}
											index={index}
											hide={hideInputValInput}
											placeholder={showPlaceHolder(item)}
											cbHandleOnPaste={handleOnPaste}
											options={options || []}
											loading={loading}
											chipLen={maxValuesAllowed}
											item={item}
											busName={businessName}
											showExpanded={(condition, val, index, busName) => {
												setShowExpandedFilter(true);
												setFilterObj({
													busName: busName,
													condition: condition,
													val: val,
													index: index
												});
											}}
										/>
										{getFilterValueCount()}
										{(ADVANCED_TEMPLATES.includes(Number(templateId)) ||
											isCustomDataset(templateId)) &&
											showAdvanceOption()}
									</FormControl>
								)}

								<ShowRangeInput item={item} index={index} />
								<DateRangeInput item={item} index={index} cbSetDateRange={handleSetDateRange} />
								<Box id="accordian-footer" className={classes.accordianFooter}>
									<Box className={classes.actionBtns} mr={1} ml={1} id="actionBtns">
										<RBButton
											id="cancelBtn"
											disabled={disableCancel(index)}
											cbHandleClick={() => handleOnCancel(index)}
											btnName={CANCEL_BUTTON}
											type="secondary"
											style={{ width: 100 }}
										/>
										<RBButton
											id="applyBtn"
											disabled={disableSave(index)}
											cbHandleClick={() => handleOnSave(item.businessName)}
											btnName={APPLY}
											type="primary"
											style={{ width: 100 }}
										/>
									</Box>
								</Box>
								{is104FeatureSelected && (
									<blockquote className={classes.warningContainer}>
										<Box className={classes.warningBox}>
											<ReportProblemOutlinedIcon className={classes.warningIcon} />
											<Box className={classes.warningInnerBox}>
												<p className={classes.warningText}>{WARNING_104_WEEKS_TEXT}</p>
												<Link
													href={`${getBaseUrl()}${
														isBasic ? PROTIP_LEARN_MORE_BASIC : PROTIP_LEARN_MORE
													}`}
													target="_blank"
													className={classes.warningLearnMoreLink}>
													{LEARN_MORE}
												</Link>
											</Box>
										</Box>
									</blockquote>
								)}
							</Box>
						</Accordion>
						{idx < list.length - 1 && <Divider style={{ width: '90%', marginLeft: '16px' }} />}
					</>
				);
			}
		});
	};

	const NoFilterSelected = () => {
		return (
			<Box
				className={classes.noFiltersSelected}
				style={{ paddingTop: !checkLocation ? '0px' : '50px', zIndex: 1 }}>
				<Box style={{ marginTop: '50px' }}>
					<Typography id="no-filter-selected">{NO_FILTER}</Typography>
					<Typography id="no-filter-selected">{TIME_FILTER_REQ}</Typography>
				</Box>
			</Box>
		);
	};

	const renderContent = () => {
		if (
			fromWhere !== 'quickReport' &&
			// -1 indicates that it is a custom dataset. And for custom dataset, we should see the required/optional filters
			![...SHOW_AS_CANNED_REPORT, ...MOD_TMPT_LIST, -1].includes(Number(templateId)) &&
			filterState?.length === 0 &&
			localUsrSelection?.length === 0
		) {
			return (
				<>
					{renderHeader()}
					<NoFilterSelected />
					{renderFooter()}
				</>
			);
		}

		if (
			fromWhere !== 'quickReport' &&
			![...SHOW_AS_CANNED_REPORT, ...MOD_TMPT_LIST].includes(Number(templateId)) &&
			prevFilterState?.length > 0 &&
			filterState?.length === 0
		) {
			return (
				<>
					{renderHeader()}
					<NoFilterSelected />
					{renderFooter()}
				</>
			);
		}

		if (showExpandedFilter) {
			return (
				<FilterExpanded
					attribute={localUsrSelection}
					filterObj={filterObj}
					handleShow={() => {
						setShowExpandedFilter(false);
						if (fromWhere === 'filterPanel') {
							cbSetShowPreviewElement(FILTER_LOWER, true);
						} else if (fromWhere !== 'quickReport') {
							cbSetShowPreviewElement('columns', true, true);
						}
					}}
					cbHandleAddChip={handleAddChip}
					cbHandleChipDelete={handleChipDelete}
				/>
			);
		}

		const getRequiredFilters = () => {
			const requiredList = [];
			filterState.forEach((item, index) => {
				let copiedItem = deepClone(item);
				if (isCalFamily(item) && item.filter.condition === '') {
					const timeFilter = selectedList.find(
						(el) => isCalFamily(el) && el.businessName === copiedItem.businessName
					);
					if (timeFilter) {
						timeFilter.filter = { condition: '', value: [] };
						copiedItem = deepClone(timeFilter);
					}
				}
				if (isDefaultFilter(copiedItem, selectedList, sbuDBTechNames, templateId)) {
					requiredList.push({ item: copiedItem, index: index });
				}
			});
			return requiredList;
		};

		const getOptionalFilters = () => {
			const optionalList = [];
			filterState.forEach((item, index) => {
				if (!isDefaultFilter(item, selectedList, sbuDBTechNames, templateId)) {
					optionalList.push({ item, index: index });
				}
			});
			return optionalList;
		};

		const getToBeEditFilterList = () => {
			const list = [];
			if (localUsrSelection.length > 0) {
				filterState.forEach((item, index) => {
					if (item.businessName === localUsrSelection[0].businessName) {
						list.push({ item, index: index });
					}
				});
			}
			return list;
		};

		const getVisualHierarchyFilter = (requiredFilters, optionalFilters) => {
			const filterItem = requiredFilters.find((filter) => filter.item.businessName === expanded);
			if (filterItem) {
				return requiredFilters;
			}
			return optionalFilters;
		};

		if (fromWhere === 'editFilter') {
			return (
				<>
					{renderHeader()}
					<ShowFilterForm list={getToBeEditFilterList()} />
					{showVHWidget && (
						<VisualHierarchyWidget
							open={showVHWidget}
							onClose={() => setShowVHWidget(false)}
							handleAddChip={handleAddChip}
							filterName={expanded}
							filterList={getToBeEditFilterList()}
						/>
					)}
				</>
			);
		}

		const requiredFilters = getRequiredFilters();
		const optionalFilters = getOptionalFilters();
		const vhFilters = getVisualHierarchyFilter(requiredFilters, optionalFilters);
		return (
			<>
				{renderHeader()}
				<Box style={{ paddingTop: !checkLocation ? '0px' : '50px', zIndex: 1 }}>
					{requiredFilters.length > 0 && (
						<>
							<Typography className={classes.typeOfFilterHeader}>{REQUIRED_FILTERS}</Typography>
							<ShowFilterForm list={requiredFilters} />
							<Divider style={{ backgroundColor: '#E3E4E5' }} />
						</>
					)}
					<Typography className={classes.typeOfFilterHeader}>
						<span style={{ width: '-webkit-fill-available' }}>{OPTIONAL}</span>
						<Button
							id="add_filter_btn"
							className={classes.addFilterBtn}
							onClick={(e) => {
								setOptions([]);
								if (
									selectedList.length === 0 ||
									(fromWhere !== 'quickReport' && CANNED_REPORT_LIST.includes(Number(templateId)))
								) {
									cbSetShowPreviewElement(FILTER_LOWER, true, true);
								} else {
									setAddFilterAnchorEl(e.currentTarget);
								}
							}}>
							<AddIcon style={{ fontSize: '16px', margin: '8px' }} />
							{ADD_FILTER_VAL}
							<ArrowDropDownIcon style={{ fontSize: '16px', margin: '8px' }} />
						</Button>
					</Typography>
					<Menu
						id="simple-menu"
						anchorEl={addFilterAnchorEl}
						keepMounted
						open={Boolean(addFilterAnchorEl)}
						onClose={() => setAddFilterAnchorEl(null)}
						PaperProps={{
							style: {
								maxHeight: 337,
								overflowY: 'auto',
								width: 328
							}
						}}
						getContentAnchorEl={null}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'center'
						}}
						transformOrigin={{
							vertical: 'top',
							horizontal: 'center'
						}}>
						{getDataInUse()}
					</Menu>
					{optionalFilters.length === 0 && (
						<Box style={{ marginTop: '50px' }}>
							<Typography className={classes.noFilterGuideContent} style={{ fontWeight: 700 }}>
								{NO_OPTIONAL_FILTER_SELECTED}
							</Typography>
							<Typography className={classes.noFilterGuideContent}>
								{GUIDE_TO_ADD_OPTIONAL_FILTER1}
							</Typography>
							<Typography className={classes.noFilterGuideContent}>
								{GUIDE_TO_ADD_OPTIONAL_FILTER2}
							</Typography>
						</Box>
					)}
					<ShowFilterForm list={optionalFilters} />
					{showVHWidget && (
						<VisualHierarchyWidget
							open={showVHWidget}
							onClose={() => setShowVHWidget(false)}
							handleAddChip={handleAddChip}
							filterName={expanded}
							filterList={vhFilters}
						/>
					)}
				</Box>
				{renderFooter()}
			</>
		);
	};

	const classes = styles();

	/** Mendate at least dimension filter in quick report panel for merchant users or canned report */
	const checkLocation = !window.location.toString().includes('rbtemplates');
	const generalButNotTimed = SHOW_AS_CANNED_REPORT.includes(Number(templateId));
	const check = !checkLocation && (userPersona === 'MERCHANT' || generalButNotTimed);
	const filterValidation =
		!checkLocation && !validateDimFilters(selectedList, filterState, Number(templateId));
	const requiredFilterCheck =
		!checkLocation && [...TENDER_ANALYSIS_LIST, ...SHIP_TO_ZIP_LIST].includes(Number(templateId));
	const { mandateInfo, mandateInfoDefault, mandateInfoError } = classes;
	const mandateInfoStyle = classNames({
		[mandateInfo]: true,
		[mandateInfoDefault]: !isDimFilterMandate,
		[mandateInfoError]: isDimFilterMandate
	});
	const requiredFilterStyle = classNames({
		[mandateInfo]: true,
		[mandateInfoDefault]: isCalFilterApplied,
		[mandateInfoError]: !isCalFilterApplied
	});

	const renderHeader = () => {
		return (
			<>
				{checkLocation && fromWhere === 'editFilter' && (
					<>
						<div className={classes.header}>
							<div className={classes.leftHeader}>
								<Typography className={classes.titleFont}>
									<IconButton
										id="back-btn"
										size="small"
										aria-label="Close"
										className={classes.titleIcon}
										onClick={() => cbSetShowPreviewElement('columns', true)}>
										<ArrowBackIcon />
									</IconButton>
									<span>{EDIT_FILTER_VALUE}</span>
								</Typography>
							</div>
						</div>
						<Divider />
					</>
				)}
				{checkLocation && fromWhere === 'filterPanel' && (
					<>
						<div
							style={{
								overflow: 'hidden',
								position: 'fixed',
								zIndex: 2,
								backgroundColor: colors.WHITE
							}}>
							<div className={classes.header} style={{ width: drawerWidth }}>
								<div className={classes.leftHeader}>
									<Typography className={classes.titleFont}>
										<FilterListIcon
											className={classes.titleIcon}
											style={{ color: colors.PURPLE }}
										/>
										<span style={{ width: '-webkit-fill-available' }}>{FILTER}</span>
										<IconButton
											aria-label="Close"
											className={`${classes.closeIcon} ${classes.floatRight}`}
											onClick={() => cbSetShowPreviewElement(FILTER_LOWER)}>
											<CloseIcon style={{ color: '#6D6E71' }} />
										</IconButton>
									</Typography>
								</div>
							</div>
							<Divider />
						</div>
					</>
				)}
				<Tour
					steps={tourSteps}
					run={runTour}
					cbHandleJoyride={handleTourCallback}
					isContinuos={false}
				/>
				{check && (
					<Box id="mandate-info" className={mandateInfoStyle}>
						{MANDATE_FILTER_MSG}
					</Box>
				)}
				{requiredFilterCheck && (
					<Box id="mandate-info" className={requiredFilterStyle}>
						{REQUIRED_FILTER_MSG}
					</Box>
				)}
				{filterValidation && (
					<Box id="mandate-info" className={`${mandateInfoStyle} ${classes.mandateInfoStyleBig}`}>
						{BLOCKED_PREVIEW_DIALOG_CONTENT_SSI}
					</Box>
				)}
			</>
		);
	};

	const renderFooter = () => {
		return (
			<Box className={classes.footer} style={{ width: drawerWidth }}>
				<Button
					id="clear-all"
					size="small"
					onClick={handleClearAllFilter}
					className={classes.button}>
					<InputLabel className={classes.clearAllLbl}>{CLEAR_ALL}</InputLabel>
				</Button>
			</Box>
		);
	};

	return (
		<div className={classes.container}>
			<PreviewDialog
				open={showCaptchaDialogBox}
				hidePrimaryBtn={true}
				hideSecondaryBtn={true}
				bodyContent={<PerimeterXCaptcha secondaryTextMsg={BOT_MODAL_FILTER_MSG} />}
			/>
			<Box style={{ paddingBottom: check ? 35 : 150 }}>{renderContent()}</Box>
			{showMTSWidget && (
				<MultiTimeSelectionWidget
					mtsState={mtsState}
					onMTSUpdate={onMTSUpdate}
					open={showMTSWidget}
					templateId={Number(templateId)}
					onClose={() => setShowMTSWidget(false)}
				/>
			)}
		</div>
	);
}

export default FilterForm;
